import { ArtistContentCardProps } from "../../types";
import { ArtistGridCard } from "./ArtistGridCard";

export function ArtistHorizontalCard(props: ArtistContentCardProps) {
  return <ArtistGridCard {...props} />;
}
